'use strict';

/* global $ */

function Menu(options) {

    let opt = $.extend({
        burger: options.selector+'__burger',
        submenu: options.selector+'__submenu',
        contacts: options.selector+'__contacts',
    }, options);

    function initBlock(el) {

        console.log('[ Menu/Init ]');

        let $el = $(el);

        $el.find(opt.burger).on('click', function(e) {
            e.preventDefault();
            $el.toggleClass('is-open');
            //$('body').addClass('m--popup');
            console.log('[ Menu/Toggle ]');
        });
        $el.find(opt.contacts).on('click', function(e) {
            console.log('[ Menu/Contacts ]');
            let browser = $('body').data('browser');
            if (browser === 'desktop') {
                e.preventDefault();
                if ($('#contacts').length) {
                    $('html, body').animate({
                        scrollTop: $('#contacts').offset().top
                    }, 1000);
                }
            }
        });
        $el.find(opt.submenu).on('click', function(e) {
            e.preventDefault();
            $(this).parent().toggleClass('is-open');
            //$('body').addClass('m--popup');
            console.log('[ Menu/Toggle submenu ]');
        });
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    Menu
};
